/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable consistent-return */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { getCurrentStaffCode, getStaffById } from '@/app/services/staff/staff';
import { Avatar, CircularProgress, IconButton, Tooltip, Typography } from '@material-ui/core/';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './staff.css';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useNavigate, useLocation } from 'react-router-dom';

const StaffInformation = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [accessCodeLoading, setAccessCodeLoading] = useState(false);
	const [accessCode, setAccessCode] = useState('');
	const location = useLocation();
	const { row } = location.state;
	const [staff, setStaff] = useState(row || {});
	const { id } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (!row) {
			setIsLoading(true);
			getStaffById(id)
				.then((res) => {
					setStaff(res.data);
				})
				.catch(() => {
					dispatch(
						Actions.showMessage({
							message: 'Failed to fetch staff information.',
							autoHideDuration: 1500,
							variant: 'error',
						})
					);
				})
				.finally(() => setIsLoading(false));
		}
	}, []);

	const handleGetStaffCode = async () => {
		setAccessCodeLoading(true);
		try {
			const response = await getCurrentStaffCode(id);
			setAccessCode(response.data.code);
		} catch (error) {
			dispatch(Actions.showMessage({ message: error.message || 'Error getting staff code', variant: 'error' }));
		} finally {
			setAccessCodeLoading(false);
		}
	};

	const fieldClasses = ' flex flex-col gap-2 md:gap-4';

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="">
				<div className="staff-div mx-auto">
					<div className="flex justify-between items-end">
						<span className="personal-hd  mt-32 mb-16">
							<div style={{ color: '#06071D', fontSize: 20, fontWeight: '700' }}>
								<span className="mr-12 icon-color ">
									<IconButton
										id="go-back"
										onClick={() => {
											navigate('/staff');
										}}
									>
										<img alt="filter" className="fiterimg" src="assets/images/arrow-long.png" width="24px" />
									</IconButton>
								</span>
								Staff Detail
							</div>
						</span>
					</div>
					<div className="bg-white rounded staff-detail">
						<span className="div-heading">
							<h2 className="edit-staff-form-heading staf-infoo" style={{ color: '#06071D', fontSize: '18px' }}>
								Staff Information
							</h2>
						</span>

						<div className=" rounded  mx-auto">
							<div className="flex flex-col md:flex-row gap-32 md:gap-72">
								<div className=" mx-auto md:mx-0">
									<Avatar className=" size-[140px]" src={staff?.thumb} />
								</div>
								{isLoading ? (
									<div className="flex justify-center items-center w-full">
										<CircularProgress className="justify-center items-center" />
									</div>
								) : (
									<div className="w-full">
										<div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-20 md:gap-36">
											<dl className={fieldClasses}>
												<dt>First Name</dt>
												<dd className="font-bold capitalize text-pd-base">{staff.first_name}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Last Name</dt>
												<dd className="font-bold capitalize text-pd-base">{staff.last_name}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Email Address</dt>
												<dd className="font-bold text-pd-base break-words">{staff.email}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Contact Number</dt>
												<dd className="font-bold text-pd-base">{staff.phone}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Emergency Contact Name</dt>
												<dd className="font-bold text-pd-base">
													{staff?.emergency_name ? staff?.emergency_name : '-'}
												</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Emergency Contact Number</dt>
												<dd className="font-bold text-pd-base">{staff.emergency_phone}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Position Type</dt>
												<dd className="font-bold text-pd-base capitalize">{staff.position_type}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Title</dt>
												<dd className="font-bold text-pd-base capitalize">{staff.title}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Admin</dt>
												<dd className="font-bold text-pd-base capitalize">{staff.admin}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Date of Birth</dt>
												<dd className="font-bold text-pd-base">{dayjs(staff.date_of_birth).format('MMM DD, YYYY')}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Address</dt>
												<dd className="font-bold text-pd-base">{staff.address}</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Employment Date</dt>
												<dd className="font-bold text-pd-base">
													{dayjs(staff.employment_date).format('MMM DD, YYYY')}
												</dd>
											</dl>
											<dl className={fieldClasses}>
												<dt>Access Code</dt>
												<dd>
													<div className="font-bold flex items-center gap-8 align-middle relative">
														<div className="relative text-pd-base">
															{accessCodeLoading ? (
																<div className="absolute left-0 bg-white/50 flex items-center justify-center w-full">
																	<CircularProgress className="text-grey" size={20} />
																</div>
															) : null}
															{accessCode ? accessCode : '****'}
														</div>

														{accessCode ? (
															<Tooltip onClick={() => setAccessCode('')} title="Hide access code">
																<button type="button">
																	<EyeSlashIcon className="size-24 cursor-pointer text-pd-blue-light/80 hover:text-pd-blue-light transition-colors duration-200" />
																</button>
															</Tooltip>
														) : (
															<Tooltip onClick={handleGetStaffCode} title="Show access code">
																<EyeIcon
																	className={`cursor-pointer ${
																		accessCodeLoading ? 'text-grey pointer-events-none' : 'text-pd-blue-light/80'
																	} hover:text-pd-blue-light transition-colors duration-200 size-24`}
																/>
															</Tooltip>
														)}
													</div>
												</dd>
											</dl>
										</div>
										<div className="mt-48">
											{staff?.document_urls?.length > 0 ? (
												<div className={fieldClasses}>
													<Typography className="">Uploaded Files</Typography>
													<div className=" flex flex-wrap gap-8">
														{staff?.document_urls?.map((e) => (
															<Tooltip key={e.id} title={e.file_name}>
																<a
																	href={e.url}
																	rel="noreferrer"
																	style={{
																		color: '#000',
																	}}
																	target="_blank"
																>
																	{e.url.split('.')[e.url.split('.').length - 1] !== 'pdf' ? (
																		<div className="attach_file_div">
																			<img
																				alt=""
																				src={e.name ? URL.createObjectURL(e) : e.url}
																				style={{
																					width: '87px',
																					height: '84px',
																					objectFit: 'cover',
																				}}
																			/>
																			<div>
																				{e.file_name?.length > 10 ? `${e.file_name.substring(0, 10)}...` : e.file_name}
																			</div>
																		</div>
																	) : (
																		<div className="attach_file_div">
																			<img
																				alt=""
																				src="assets/images/pdf_thumbnail.png"
																				style={{
																					width: '87px',
																					height: '84px',
																					objectFit: 'cover',
																				}}
																			/>
																			<div>
																				{e.file_name?.length > 10 ? `${e.file_name.substring(0, 10)}...` : e.file_name}
																			</div>
																		</div>
																	)}
																</a>
															</Tooltip>
														))}
													</div>
												</div>
											) : null}
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default StaffInformation;
